/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CreateGetThereUrlViewModel } from '../models/CreateGetThereUrlViewModel';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class GetThereService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param requestBody
     * @returns CreateGetThereUrlViewModel
     * @throws ApiError
     */
    public getThereCreateUrl(
        requestBody: Record<string, string | null>,
    ): Observable<CreateGetThereUrlViewModel> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/getthere/createUrl',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
